import 'common/scripts/polyfills';
import { haveJS } from '../../src/common/scripts/common';
import AlertOldBrowser from '../../src/components/alert-old-browser';
import App from './App.vue';
import Observer from '../../src/common/scripts/observer';
import {initCookie} from '../../src/common/scripts/common';
import router from './router';
import store from './store';
import Vue from 'vue';

const observer = new Observer();

haveJS();

const wrapper = document.querySelector('#visual');
const complexId = wrapper ? (wrapper as HTMLElement).dataset.complexId || false : false;
Vue.prototype.$prevLink = '//rbi.ru';
Vue.prototype.$dataset = {...(wrapper as HTMLElement).dataset};

router.beforeEach((to, from, next) => {
    // @ts-ignore
    if (to.meta.isFlat) {
        // @ts-ignore
        store.commit('SET_IS_FLAT', to.meta.isFlat);
    } else {
        store.commit('SET_IS_FLAT', false);
        store.commit('SET_PATH', to.path);
    }
    if (!from.name && document.referrer.indexOf('rbi.ru') !== -1) {
        Vue.prototype.$prevLink = document.referrer;
    }
    if (!to.params.hasOwnProperty('complexId') && complexId) {
        to.params.complexId = complexId;
    }

    for (const param in Vue.prototype.$dataset) {
        if (!to.params.hasOwnProperty(param)) {
            to.params[param] = Vue.prototype.$dataset[param];
        }
    }
    next();
});

Vue.config.productionTip = false;

Vue.prototype.$appOptions = {
    fill: '#937545'
};

new Vue({
    router,
    store,
    render: (h) => {
        return h(App);
    }
}).$mount('#visual');

// Непопап про cookies
const cookiePopup = document.querySelector('.j-cookie');

if (cookiePopup) {
    initCookie();
}

observer.subscribe('dataStep', (step) => {
    window.parent.postMessage({message: step}, '*');
});




new AlertOldBrowser().init();
